import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { PRODUCTS, SOLUTIONS, INDUSTRIES } from "../../lib/marketingContent";

const COLS = [
  {
    title: "Platform",
    links: Object.values(PRODUCTS).map((p) => ({ to: `/products/${p.slug}`, label: p.name })),
  },
  {
    title: "Solutions",
    links: Object.values(SOLUTIONS).map((s) => ({ to: `/solutions/${s.slug}`, label: s.name })),
  },
  {
    title: "Industries",
    links: Object.values(INDUSTRIES).map((i) => ({ to: `/industries/${i.slug}`, label: i.name })),
  },
  {
    title: "Company",
    links: [
      { to: "/why-argus", label: "Why ArgusSecure" },
      { to: "/landscape", label: "Tool Landscape" },
      { to: "/customers", label: "Customer Stories" },
      { to: "/about", label: "About" },
      { to: "/resources/library", label: "Resources" },
      { to: "/docs/setup", label: "Setup Guide" },
      { to: "/pricing", label: "Pricing" },
      { to: "/status", label: "Status" },
      { to: "/trust", label: "Trust" },
      { to: "/abuse", label: "Report Abuse" },
    ],
  },
];

const LEGAL_LINKS = [
  { to: "/legal/terms", label: "Terms" },
  { to: "/legal/privacy", label: "Privacy" },
  { to: "/legal/responsible-disclosure", label: "Responsible Disclosure" },
  { to: "/legal/acceptable-use", label: "Acceptable Use" },
  { to: "/legal/dpa", label: "DPA" },
];

export default function Footer() {
  return (
    <footer className="bg-panel border-t border-line text-ink" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-6 gap-8">
        <div className="col-span-2">
          <Logo size={24} />
          <p className="mt-4 text-sm text-ink/60 max-w-sm">
            Find it before they do. Continuous SAST, DAST and SCA for teams who ship fast.
          </p>
          <div className="mt-6 flex flex-wrap gap-2 text-[10px] uppercase tracking-wider text-ink/40">
            <span className="inline-flex items-center gap-1.5 px-2 py-1 border border-line rounded">SOC 2 — on track</span>
            <span className="inline-flex items-center gap-1.5 px-2 py-1 border border-line rounded">ISO 27001 — on track</span>
            <span className="inline-flex items-center gap-1.5 px-2 py-1 border border-line rounded">GDPR & CCPA aligned</span>
          </div>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="text-[11px] uppercase tracking-wider text-ink/40 mb-3 font-semibold" data-testid={`footer-col-${c.title.toLowerCase()}`}>
              {c.title}
            </h4>
            <ul className="space-y-2 text-sm">
              {c.links.map((l) => (
                <li key={l.to + l.label}>
                  <Link to={l.to} className="text-ink/70 hover:text-gold transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-line">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-ink/50">
          <span>© 2026 ArgusSecure, a GSGD FIELD SOLUTIONS ENGINEERING product. All rights reserved.</span>
          <span className="flex flex-wrap gap-x-4 gap-y-2">
            {LEGAL_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-ink" data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </Link>
            ))}
          </span>
        </div>
      </div>
    </footer>
  );
}
